<div class="product-list-section-container">
  <img src="assets/images/builder-v2/product_list.svg">
  <span>{{ 'text_yourProductsWillBeShowcasedHere' | dbText }}</span>
</div>
